"use strict";

import ComponentHeader from "./components/component-header";
// import Header from "./components/header";

// import AOS from 'aos';
import Header from "./components/header";
import Footer from "./components/footer";
import ComponentHeaderInternas from "./components/component-header_internas";
import ComponentListagemPacotePromocoes from "./components/component-listagem_pacotes_promocoes";
import ComponentListagemPacotePassagens from "./components/component-listagem_pacotes_passagens";
import ComponentVideo from "./components/component-video";
import ComponentSliderResorts from "./components/component-slider_resorts";
import ComponentCardsFotoTituloDescricaoCta3Colunas from "./components/component-cards_foto_titulo_descricao_cta_3_colunas";
import ComponentPremios from "./components/component-premios";
import ComponentDestaquesBlog from "./components/component-destaques_blog";
import ComponentSliderComChamadaEBotoes from "./components/component-slider_com_chamada_e_botoes";
import ComponenTituloSubtituloListaCards from "./components/component-titulo_subtitulo_lista_cards";
import ComponentRelatorios from "./components/component-relatorios";
import ComponentSliderPadrao from "./components/component-slider_padrao";
import ComponentTituloSubtituloSliderImagens from "./components/component-titulo_subtitulo_slider_imagens";
import ComponentIngressos from "./components/component-ingressos";
import ComponentBlog3PostsDestaque from "./components/component-blog_3_posts_destaque";
import ComponentAtracesDestaque from "./components/component-atracoes_destaque";
import ComponentCalendario from "./components/component-calendario";
import ComponentResorts from "./components/component-resorts";
import PageSingleBlog from "./pages/single-blog";
import ComponentTimeline from "./components/component-timeline";
import ComponentCardsFotoTituloDescricaoCta2Colunas from "./components/component-cards_foto_titulo_descricao_cta_2_colunas";
import ComponentListaDeCardsComIconeTituloDescricaoSidebarComTituloDescricaoCta from "./components/component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta";
import ComponentDepoimentos from "./components/component-depoimentos";
import ComponentBeachCard from "./components/component-beach_card";
import ComponentSliderConteudos from "./components/component-slider_conteudos";
import ComponentPerguntasFrequentes from "./components/component-perguntas_frequentes";
import AccessibilityFontSite from "./accessibility/font-size";
import AccessibilitySiteTheme from "./accessibility/site-theme";
import ComponentFormularioContato from "./components/component-formulario_contato";
import ComponentListaDeCardsComIconeTituloDescricao from "./components/component-lista_de_cards_com_icone_titulo_descricao";
import ComponentFiltroAtracoes from "./components/component-filtro_atracoes";
import ComponentTituloSubtituloAccordeonSliderFotos from "./components/component-titulo_subtitulo_accordeon_slider_fotos";
import ComponentFormularioSejaNossoParceiro from "./components/component-seja_nosso_parceiro";
import ComponentCategoriasBlog from "./components/component-categorias_blog";

export default class App {
    constructor() {

        new Header();
        new AccessibilityFontSite();
        new AccessibilitySiteTheme();
        new Footer();
        // new Forms();

        // AOS.init({
        //     duration: 1500,
        //     once: true
        // });

        // setInterval(() => {
        //     AOS.refresh();
        // }, 500);

        const ComponentHeaderElement = document.querySelector('.component-header')
        const ComponentHeaderInternasElement = document.querySelector('.component-header_internas')
        const ComponentListagemPacotesPromocoesElement = document.querySelector('.component-listagem_pacotes_promocoes')
        const ComponentListagemPacotesPassagensElement = document.querySelector('.component-listagem_pacotes_passagens')
        const ComponentVideoElement = document.querySelector('.component-video')
        const ComponentSliderResortsElement = document.querySelector('.component-slider_resorts')
        const ComponentCardsFotoTituloDescricaoCta3ColunasElement = document.querySelector('.component-cards_foto_titulo_descricao_cta_3_colunas')
        const ComponentPremiosElement = document.querySelector('.component-premios')
        const ComponentDestaquesBlogElement = document.querySelector('.component-destaques_blog')
        const ComponentSliderComChamadaEBotoesElement = document.querySelector('.component-slider_com_chamada_e_botoes')
        const ComponentTituloSubtituloListaCardsElement = document.querySelector('.component-titulo_subtitulo_lista_cards')
        const ComponentRelatoriosElement = document.querySelector('.component-relatorios')
        const ComponentSliderPadraoElement = document.querySelector('.component-slider_padrao')
        const ComponentTituloSubtituloSliderImagensElement = document.querySelector('.component-titulo_subtitulo_slider_imagens')
        const ComponentIngressosElement = document.querySelector('.component-ingressos')
        const ComponentBlog3PostsDestaqueElement = document.querySelector('.component-blog_3_posts_destaque')
        const ComponentAtracesDestaqueElement = document.querySelector('.component-atracoes_destaque')
        const ComponentCalendarioElement = document.querySelector('.component-calendario')
        const ComponentResortsElement = document.querySelector('.component-resorts')
        const ComponentTimelineElement = document.querySelector('.component-timeline')
        const ComponentCardsFotoTituloDescricaoCta2ColunasElement = document.querySelector('.component-cards_foto_titulo_descricao_cta_2_colunas')
        const ComponentListaDeCardsComIconeTituloDescricaoSidebarComTituloDescricaoCtaElement = document.querySelector('.component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta')
        const ComponentDepoimentosElement = document.querySelector('.component-depoimentos')
        const ComponentBeachCardElement = document.querySelector('.component-beach_card')
        const ComponentSliderConteudosElement = document.querySelector('.component-slider_conteudos')
        const ComponentPerguntasFrequentesElement = document.querySelector('.component-perguntas_frequentes')
        const ComponentFormularioContatoElement = document.querySelector('.component-formulario_contato')
        const ComponentSejaNossoParceiro = document.querySelector('.component-seja_nosso_parceiro')
        const ComponentListaDeCardsComIconeTituloDescricaoElement = document.querySelector('.component-lista_de_cards_com_icone_titulo_descricao')
        const ComponentFiltroAtracoesElement = document.querySelector('.component-filtro_atracoes')
        const ComponentTituloSubtituloAccordeonSliderFotosElement = document.querySelector('.component-titulo_subtitulo_accordeon_slider_fotos')
        const ComponentCategoriasBlogElement = document.querySelector('.component-lista_categorias_blog')

        const PageSingleBlogElement = document.querySelector('.single-blog')

        // -> Components
        ComponentHeaderElement ? new ComponentHeader() : null
        ComponentHeaderInternasElement ? new ComponentHeaderInternas() : null
        ComponentListagemPacotesPromocoesElement ? new ComponentListagemPacotePromocoes() : null
        ComponentListagemPacotesPassagensElement ? new ComponentListagemPacotePassagens() : null
        ComponentVideoElement ? new ComponentVideo() : null
        ComponentSliderResortsElement ? new ComponentSliderResorts() : null
        ComponentCardsFotoTituloDescricaoCta3ColunasElement ? new ComponentCardsFotoTituloDescricaoCta3Colunas() : null
        ComponentPremiosElement ? new ComponentPremios() : null
        ComponentDestaquesBlogElement ? new ComponentDestaquesBlog() : null
        ComponentSliderComChamadaEBotoesElement ? new ComponentSliderComChamadaEBotoes() : null
        ComponentTituloSubtituloListaCardsElement ? new ComponenTituloSubtituloListaCards() : null
        ComponentRelatoriosElement ? new ComponentRelatorios() : null
        ComponentSliderPadraoElement ? new ComponentSliderPadrao() : null
        ComponentTituloSubtituloSliderImagensElement ? new ComponentTituloSubtituloSliderImagens() : null
        ComponentIngressosElement ? new ComponentIngressos() : null
        ComponentBlog3PostsDestaqueElement ? new ComponentBlog3PostsDestaque() : null
        ComponentAtracesDestaqueElement ? new ComponentAtracesDestaque() : null
        ComponentCalendarioElement ? new ComponentCalendario() : null
        ComponentResortsElement ? new ComponentResorts() : null
        ComponentTimelineElement ? new ComponentTimeline() : null
        ComponentCardsFotoTituloDescricaoCta2ColunasElement ? new ComponentCardsFotoTituloDescricaoCta2Colunas() : null
        ComponentListaDeCardsComIconeTituloDescricaoSidebarComTituloDescricaoCtaElement ? new ComponentListaDeCardsComIconeTituloDescricaoSidebarComTituloDescricaoCta() : null
        ComponentDepoimentosElement ? new ComponentDepoimentos() : null
        ComponentBeachCardElement ? new ComponentBeachCard() : null
        ComponentSliderConteudosElement ? new ComponentSliderConteudos() : null
        ComponentPerguntasFrequentesElement ? new ComponentPerguntasFrequentes() : null
        ComponentFormularioContatoElement ? new ComponentFormularioContato() : null
        ComponentSejaNossoParceiro ? new ComponentFormularioSejaNossoParceiro() : null
        ComponentListaDeCardsComIconeTituloDescricaoElement ? new ComponentListaDeCardsComIconeTituloDescricao() : null
        ComponentFiltroAtracoesElement ? new ComponentFiltroAtracoes() : null
        ComponentTituloSubtituloAccordeonSliderFotosElement ? new ComponentTituloSubtituloAccordeonSliderFotos() : null
        ComponentCategoriasBlogElement ? new ComponentCategoriasBlog() : null

        // -> Pages
        PageSingleBlogElement ? new PageSingleBlog() : null

    }
}

new App();

// Função para carregar o script do reCAPTCHA
export function loadRecaptcha(callback) {
    const url = 'https://www.google.com/recaptcha/enterprise.js';

    // Verifica se o script do reCAPTCHA Enterprise está carregado
    if (typeof grecaptcha !== 'undefined') {
        console.log('reCAPTCHA Enterprise está carregado.');
        // console.log('reCpatcha enterpise: ', grecaptcha.enterprise)
        // console.log('reCpatcha enterprise response: ', grecaptcha.enterprise.getResponse())
    } else {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = url;    
        const x = document.getElementsByTagName('head')[0];
        x.appendChild(s);
    }

}



// Função para recarregar o captcha e obter um novo token
window.reloadCaptcha = function reloadCaptcha(action, fieldName = 'g-recaptcha-response', fn = null) {
    grecaptcha.enterprise.ready(function () {
        const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');

        if (!siteKey) {
            console.error("Site key not found. Please add a meta tag with name 'rv3:sitekey' and content with your site key.");
            return;
        }

        grecaptcha.enterprise
            .execute(siteKey, {
                action: action,
            })
            .then(function (token) {
                const inputElement = document.querySelector("input[name='" + fieldName + "']");
                if (inputElement) {
                    inputElement.value = token;
                }

                if (fn) {
                    fn();
                }
            });
    });
};
